export default {"src":"/_next/static/media/data.a7ff4f1d.svg","height":24,"width":24};